import React, { useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  setFilter,
  setFilterMinPrice,
  setFilterMaxPrice,
  resetPropertyFilters,
} from '../../actions'

import useFilterProperties from '../../hooks/useFilterProperties'

const optionList = ({ items }) => {
  return items.map((item) => (
    <option key={item.label} value={item.value}>
      {item.label}
    </option>
  ))
}

function Seacher({ list, showDesktop }) {
  const [popup, setPopup] = useState('')
  const buttonRef = useRef(null)
  const formRef = useRef(null)

  const classAdvanced = showDesktop
    ? 'advanced text-center'
    : 'advanced text-center hide'

  const {
    operation_types,
    property_types,
    operation_type,
    property_type,
    property_code,
    filters,
  } = useSelector((state) => ({
    operation_types: state.filters.operation_types,
    property_types: state.filters.property_types,
    property_type: state.properties.property_type,
    operation_type: state.properties.operation_type,
    property_code: state.properties.property_code,
    filters: state.properties.filters,
  }))
  const dispatch = useDispatch()

  const { fetchData, fetchAllProperties } = useFilterProperties()

  const filterAndClose = async (e) => {
    await fetchData(e)
    setPopup('')
  }

  const handleSelectChange = (e, type) => {
    dispatch(setFilter({ id: e.target.value, filter: type }))
  }

  const sanitizePriceInput = (value) => {
    if (!value) {
      return ''
    }

    const digitsOnly = value.replace(/[^\d]/g, '')
    return digitsOnly
  }

  const handlePriceChange = (e, type) => {
    const sanitized = sanitizePriceInput(e.target.value)
    if (sanitized !== e.target.value) {
      e.target.value = sanitized
    }

    if (type === 'min') {
      dispatch(setFilterMinPrice({ value: sanitized }))
    } else {
      dispatch(setFilterMaxPrice({ value: sanitized }))
    }
  }

  const handleReset = async () => {
    dispatch(resetPropertyFilters())
    if (formRef.current) {
      formRef.current.reset()
    }
    await fetchAllProperties()
    setPopup('')
  }

  const hasActiveFilters = Boolean(
    (filters && (
      filters.price_min ||
      filters.price_max ||
      filters.property_type ||
      filters.operation_type ||
      filters.property_code
    )) ||
      property_type ||
      operation_type ||
      property_code
  )

  return (
    <div className='col-12 col-xl-3 searcher'>
      <ul>
        <li
          className='searcher__input d-flex justify-content-between align-items-center'
          onClick={() => setPopup('popup')}
        >
          <p className='input'>
            COMPRAR
            <span>
              <img src='../images/search-solid.svg' alt='¿Qué buscas hoy?' />
            </span>
          </p>
          {list && (
            <p className='list'>
              <img
                className='img-fluid'
                src='../images/list-ul.svg'
                alt='Mostrar en lista'
              />
            </p>
          )}
        </li>
      </ul>

      <div className={popup} id='popup'>
        <div className={classAdvanced}>
          <div className='close' onClick={() => setPopup('')}>
            x
          </div>
          <h4 className='h4 mb-4'>Búsqueda avanzada</h4>
          <form ref={formRef} onSubmit={(e) => filterAndClose(e)}>
            <div className='form-group'>
              <label>Tipo de Propiedad</label>
              <select
                className='form-control'
                disabled={!!property_code}
                style={{ backgroundImage: `url(../images/arrow-select.svg)` }}
                onChange={(e) => handleSelectChange(e, 'property_type')}
                value={
                  property_type !== null && property_type !== undefined
                    ? property_type
                    : property_types[0].value
                }
              >
                {optionList({ items: property_types, dispatch })}
              </select>
            </div>
            <div className='form-group'>
              <label>Tipo de operación</label>
              <select
                className='form-control'
                disabled={!!property_code}
                style={{ backgroundImage: `url(../images/arrow-select.svg)` }}
                onChange={(e) => handleSelectChange(e, 'operation_type')}
                value={
                  operation_type !== null && operation_type !== undefined
                    ? operation_type
                    : operation_types[0].value
                }
                key={
                  operation_type !== null && operation_type !== undefined
                    ? operation_type
                    : operation_types[0].value
                }
              >
                {optionList({ items: operation_types, dispatch })}
              </select>
            </div>
            <div className='form-group'>
              <label>Precio Mínimo</label>
              <input
                type='text'
                disabled={!!property_code}
                pattern='[0-9]*'
                inputMode='numeric'
                className='form-control'
                name='min_price'
                onChange={(e) => handlePriceChange(e, 'min')}
                placeholder='0'
              />
            </div>
            <div className='form-group'>
              <label>Precio Máximo</label>
              <input
                type='text'
                disabled={!!property_code}
                pattern='[0-9]*'
                inputMode='numeric'
                className='form-control'
                name='max_price'
                onChange={(e) => handlePriceChange(e, 'max')}
                placeholder='99.999.999'
              />
            </div>

            <div className='d-flex mt-3'>
              {hasActiveFilters && (
                <button
                  type='button'
                  className='btn btn-reset ml-auto mr-2'
                  onClick={handleReset}
                  disabled={!!property_code}
                >
                  Limpiar filtros
                </button>
              )}
              <button
                type='submit'
                className={`btn btn-primary ${hasActiveFilters ? '' : 'ml-auto'}`}
                ref={buttonRef}
              >
                Buscar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Seacher
